import { Button, CircularProgress, Icon, IconButton, Input, Paper, Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";
import { useState, useEffect } from 'react';
import ArtApi from "../api/ArtApi";
import Moment from 'react-moment';
import { Link } from "react-router-dom";
import IEventSummary from "../models/EventSummary";
import UserInfo from "./UserInfo";

interface IEventsProps {
    userOnly: boolean,
    getArchived?: boolean,
    taskType: string,
    filterText?: string,
}

export const EventsTable = (props: IEventsProps) => {
    const [error, setError] = useState<string | null>(null);
    const [events, setEvents] = useState<IEventSummary[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [limit] = useState(10);
    const [skip, setSkip] = useState(0);

    const nextPage = () => {
        setSkip(skip + limit);
    };

    const previousPage = () => {
        setSkip(skip - limit);
    };

    const reloadList = function() {
        setIsLoading(true);
        ArtApi.getEvents(props.userOnly, limit, skip, props.taskType, props.getArchived, props.filterText)
            .then(response => {
                setEvents(response.response);
                setIsLoading(false);
            })
            .catch(error => {
                setError(error.message);
                setIsLoading(false);
            });
    };

    useEffect(reloadList, [
        skip,
        limit,
        props.userOnly,
        props.getArchived,
        props.taskType,
        props.filterText
    ]);

    return (
        <Paper className="paper">
            <Table classes={{ root: "reactivetable" }}>
                <TableHead>
                    <TableRow>
                        <TableCell>Device ID</TableCell>
                        <TableCell>Created By</TableCell>
                        <TableCell>Start Date</TableCell>
                        <TableCell>End Date</TableCell>
                        <TableCell>Details</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {events.map((event, i) => (
                        <TableRow key={i}>
                            <TableCell>
                                <a href={"https://mfgweb.alertlabs.com/device/" + event.deviceId}>
                                    {event.deviceId}
                                </a>
                            </TableCell>
                            <TableCell><UserInfo userId={event.reportedBy} /></TableCell>
                            <TableCell><Moment format="YYYY-MM-DD">{event.regionOfInterestStartDate}</Moment></TableCell>
                            <TableCell><Moment format="YYYY-MM-DD">{event.endDate}</Moment></TableCell>
                            <TableCell>
                                <Link to={props.taskType + "/" + event._id}>
                                    <Button variant="contained" color="primary">
                                        Details
                                    </Button>
                                </Link>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            {isLoading && <CircularProgress color="secondary" />}
            {error}
            {skip !== 0 && (
                <IconButton onClick={previousPage}>
                    <Icon>arrow_back</Icon>
                </IconButton>
            )}
            {events.length !== 0 && limit === events.length && (
                <IconButton onClick={nextPage}>
                    <Icon>arrow_forward</Icon>
                </IconButton>
            )}
        </Paper>
    )
}